import { useMemo } from 'react';

export const usePhoneFormat = (text: string) => {
    const formattedPhone = useMemo(() => {
        return text && text.length === 10
            ? `(${text.substring(0, 3)}) ${text.substring(3, 6)}-${text.substring(6)}`
            : text;
    }, [text]);

    return formattedPhone;
};
